/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

 import React from "react"
 import PropTypes from "prop-types"
 import { Helmet } from "react-helmet"
 import { ACTION_TYPES, ACTION_DESC_TYPES, getPriceStr, getSizeStr, toTitleCase, propertyTypesH1, getPropAddr } from "./utils"

 import { useLocation } from "@reach/router"
 
 import _ from "lodash"
 export { ACTION_TYPES, ACTION_DESC_TYPES, getPriceStr } from "./utils";

 export const getPropertyDetailUrl = (hit, siteUrl = "https://www.strettons.co.uk") => {
   const normalizedSiteUrl = (siteUrl || "https://www.strettons.co.uk").replace(/\/+$/, "");
   let uriStr = "";

   if (hit?.search_type === "sales" && hit?.department === "residential") {
     uriStr = "residential-property-for-sale/";
   } else if (hit?.search_type === "lettings" && hit?.department === "residential") {
     uriStr = "residential-property-to-rent/";
   } else if (hit?.search_type === "sales" && hit?.department === "commercial") {
     uriStr = "commercial-property-for-sale/";
   } else if (hit?.search_type === "lettings" && hit?.department === "commercial") {
     uriStr = "commercial-property-to-rent/";
   } else if (hit?.search_type === "sales" && hit?.department === "auction_residential") {
     uriStr = "auction-residential-property-for-sale/";
   } else if (hit?.search_type === "sales" && hit?.department === "auction_commercial") {
     uriStr = "auction-commercial-property-for-sale/";
   }

   const propId = hit?.objectID || hit?.id || "";
   const rawPath = `/${uriStr}${hit?.slug || ""}-${propId}/`.replace(/\/+/g, "/");
   const fullUrl = `${normalizedSiteUrl}${rawPath}`;
   try {
     return encodeURI(decodeURI(fullUrl));
   } catch (e) {
     return encodeURI(fullUrl);
   }
 };

 export const getPropertyCardName = (hit) => {
   if (hit?.department === "commercial" && hit?.address) {
     const addrCommercial = [];
     const addrCommercial2 = [];
     if (hit.address.address0) addrCommercial.push(hit.address.address0);
     if (hit.address.address1) addrCommercial.push(hit.address.address1);
     if (hit.address.address3) addrCommercial2.push(hit.address.address3);
     if (hit.address.address4) addrCommercial2.push(hit.address.address4);
     if (hit.address.postcode) addrCommercial2.push(hit.address.postcode);
     const combined = [...addrCommercial, ...addrCommercial2].filter(Boolean).join(", ");
     if (combined) return combined;
   }
   const addr = hit?.display_address ? getPropAddr(hit.display_address, hit?.postcode) : "";
   return addr || hit?.display_address || hit?.title || "";
 };

 export const buildSearchResultsSchema = ({
   pageUrl,
   siteUrl = "https://www.strettons.co.uk",
   name,
   description,
   mainEntityName,
   items = [],
 }) => {
   const normalizedSiteUrl = (siteUrl || "https://www.strettons.co.uk").replace(/\/+$/, "");
   const itemListElement = (Array.isArray(items) ? items : []).map((hit, index) => ({
     "@type": "ListItem",
     "position": index + 1,
     "url": hit?.url || getPropertyDetailUrl(hit, normalizedSiteUrl),
     "name": hit?.name || getPropertyCardName(hit),
   }));

   return {
     "@context": "https://schema.org",
     "@type": "SearchResultsPage",
     "@id": `${pageUrl}#webpage`,
     "url": pageUrl,
     "name": name,
     "description": description,
     "isPartOf": {
       "@type": "WebSite",
       "@id": `${normalizedSiteUrl}/#website`,
       "url": `${normalizedSiteUrl}/`,
       "name": "Strettons",
     },
     "publisher": {
       "@type": "Organization",
       "@id": `${normalizedSiteUrl}/#organization`,
       "name": "Strettons",
       "url": `${normalizedSiteUrl}/`,
     },
     "mainEntity": {
       "@type": "ItemList",
       "name": mainEntityName,
       "numberOfItems": itemListElement.length,
       "itemListElement": itemListElement,
     },
   };
 };
 
 const SeoResults = ({ description, lang, meta, title, searchParams, location, pcategorytype, srch_department, hits = [] }) => {
 
   const {areas, bedrooms, pType, type, price, commType, mustInclude, size } = searchParams;

   var replace_url = pcategorytype+"_"+pType;

   var h1_type = type ? propertyTypesH1[type] : "";

   const actionStr = ACTION_TYPES[replace_url];

   const actionStrDesc = ACTION_DESC_TYPES[replace_url];

   const priceStr = getPriceStr(price)
   const sizeStr = getSizeStr(size)

   const bedRooms = searchParams.bedrooms
 
   const capitalize = (s) => {
     if (typeof s !== 'string') return ''
     return s.charAt(0).toUpperCase() + s.slice(1)
   }
 
   let propertyType = "";


   if(h1_type === "") {
     propertyType = "property"
   } else if(h1_type == "apartment") {
     propertyType = "apartments"
   } else if(h1_type == "house") {
     propertyType = "houses"
   } else if(h1_type == "bungalow") {
     propertyType = "bungalows"
   } else {
     propertyType = capitalize(h1_type.replace(/-/g, ' '))
   }
 
   let mustIncludeTitle = ""
 
   if ( mustInclude ) {
     mustIncludeTitle = " with "+mustInclude.join(' and ').replace("parking", "Parking").replace("chain", "Chain").replace("outside", "Outside").replace(/-/g, ' ')
   }
 
   let desc = "";
   desc = "Discover a wide range of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + mustIncludeTitle+" with Strettons Estate Agents. To filter these results, use our filter below, or for more information about "+ pType+ " property in " + toTitleCase(areas.replace(/-/g, ' ')) + ". please contact us.";
 
   if ('UK' !== areas) {
     desc = "Discover a wide range of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + mustIncludeTitle+" with Strettons Estate Agents. To filter these results, use our filter below, or for more information about "+ pType+ " property in " + toTitleCase(areas.replace(/-/g, ' ')) + ". please contact us.";
   }
 
   if ('sales' === pType) {
     desc = "Discover a wide range of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + mustIncludeTitle+" with Strettons Estate Agents. To filter these results, use our filter below, or for more information about "+ pType+ " property in " + toTitleCase(areas.replace(/-/g, ' ')) + ". please contact us.";
 
     if ('UK' !== areas) {
         desc = "Discover a wide range of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + mustIncludeTitle+" with Strettons Estate Agents. To filter these results, use our filter below, or for more information about "+ pType+ " property in " + toTitleCase(areas.replace(/-/g, ' ')) + ". please contact us.";
     }
   } else {
     // price
     if (price.min || price.max){
       desc = propertyType + actionStr + areas + "."
     }
 
   }

   let meta_desc = description;

   //console.log("areas", areas, searchParams)

   var area_capitalize = capitalize(areas.replace(/-/g, ' '))

    if(pcategorytype){
        var department = "";
        if(pcategorytype === "commercial"){
          department = "commercial";
        } else if(pcategorytype === "auction_commercial" || pcategorytype === "auction_residential"){
          department = "auction";
        }
        
        if(pcategorytype === "commercial" || pcategorytype === "residential"){
          if(areas.toLowerCase() !== "london"){
            meta_desc = `Explore our range of ${department} property ${actionStrDesc} in ${area_capitalize}. Contact our property experts to find the right property ${actionStrDesc} in ${area_capitalize}.`
          }
          
        } 
        
        if(pcategorytype === "auction_commercial" || pcategorytype === "auction_residential"){
          if(areas.toLowerCase() !== "uk"){
            meta_desc = `Explore our range of ${department} property available ${actionStrDesc} in ${area_capitalize}. Contact our property experts to get your desired property through auction in ${area_capitalize}.`
          }
        }

        if(h1_type){
          if(h1_type === "Investments") {
              meta_desc = `Explore a wide range of investment properties for sale in London with Strettons. Find prime commercial opportunities and investment properties for sale to suit your needs.`
          }else{
              meta_desc = `Looking for ${h1_type.replace(/-/g, ' ').toLowerCase()} ${actionStrDesc} in ${area_capitalize}? Strettons ${department} estate agents are here to help.`
          }
        }

        if(pcategorytype === "commercial") {
            if(h1_type){
              let hTitle = h1_type.replace(/-/g, ' ').toLowerCase().replace("medicals space", "medical property")
              hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("industrials & logistics space", "Industrials & Logistics property")              
              hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("investments", "investments property")
              hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("lands & developments", "Land & Development opportunities")
              hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("studios & workshops space", "Studios & Workshops property")
              hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("studios & gallery space", "Studios & Gallery property")
              hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("retail space", "retail property")
              hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("leisure & hospitality space", "Leisure & Hospitality property")
              meta_desc = `Looking for ${hTitle.replace(/-/g, ' ').toLowerCase()} ${actionStrDesc} in ${area_capitalize}? Strettons ${department} agents are here to help.`
            }
            if(h1_type === "Others") {
                title = title.replace("Commercial space", "Other commercial use")
                meta_desc = `Looking for commercial space ${actionStrDesc} in ${area_capitalize}? Strettons ${department} agents are here to help.`
            }
            title = title.replace("with size", "")
        }
        //console.log("h1_type", h1_type, title)
        if(pcategorytype === "residential") {
            if(h1_type==="") {
              title = title.replace("Residential property", "Property")
            }else{
                 meta_desc = `Looking for ${h1_type.replace(/-/g, ' ').toLowerCase().replace("flats","flat").replace("houses","house")} ${actionStrDesc} in ${area_capitalize}? Strettons ${department} estate agents are here to help.`
            }
        }

        var bed_room = bedRooms === 0 ? "studio" : (bedRooms >= 1 && "more than "+bedRooms+" bedrooms");

        if(bed_room){
          meta_desc = `Explore property ${actionStrDesc} in ${area_capitalize} with ${bed_room} here. Contact our expert estate agents today to get assistance in finding the right property in ${area_capitalize}.`
        }

        if(priceStr) {
          if(pcategorytype === "residential"){
            meta_desc = `Locate the right property ${actionStrDesc} in ${area_capitalize} ${priceStr} with Strettons estate agents. Book an appointment with one of our property experts in ${area_capitalize}.`
          } else if(pcategorytype === "commercial" && searchParams?.pType === "sales") {
            meta_desc = `Locate the right property ${actionStrDesc} in ${area_capitalize} ${priceStr} with Strettons Commercial Agents. Book an appointment with one of our property experts in ${area_capitalize}.`
          } else if(pcategorytype === "commercial" && searchParams?.pType === "lettings") {
            meta_desc = `Locate the right property ${actionStrDesc} in ${area_capitalize} ${priceStr} with Strettons Commercial Agents. Book an appointment with one of our property experts in ${area_capitalize}.`
          } else{
            meta_desc = `Find the right auction property ${actionStrDesc} in ${area_capitalize} ${priceStr} with Strettons estate agents. Book an appointment with one of our property experts in ${area_capitalize}.`
          }         
        }

       // console.log("actionStrDesc=>", actionStrDesc, searchParams, h1_type)

        if(sizeStr){
            meta_desc = `Identify the ${department} property ${actionStrDesc} in ${area_capitalize} ${sizeStr}. Book a viewing with Strettons ${department} agents.`
            if(searchParams?.pType === "sales") {
               meta_desc = `Search ${department} property ${actionStrDesc} in ${area_capitalize} from ${sizeStr.replace("with size from","")}. Book a viewing with Strettons Commercial Agency.`
              // title = title.replace("from", "with size from")
            }
        }

        if(priceStr && sizeStr){
          meta_desc = `Check out the latest collection of ${department} properties ${actionStrDesc} in ${area_capitalize} ${priceStr} ${sizeStr} with Strettons Commercial Agents in ${area_capitalize}.`
          if(pcategorytype === "commercial" && searchParams?.pType === "sales") {
             meta_desc = `Check out the latest collection of ${department} properties ${actionStrDesc} in ${area_capitalize} ${priceStr} ${sizeStr.replace("with size","")} with Strettons Commercial Agents in ${area_capitalize}.`  
             //title = title.replace("from", "with size from")
          }
        }

        if(h1_type && priceStr){
          let hTitle = h1_type.replace(/-/g, ' ').toLowerCase().replace("medicals space", "medical property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("industrials & logistics space", "Industrials & Logistics property")
          //hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("educationals space", "Educationals property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("investments", "investments property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("lands & developments", "Land & Development opportunities")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("studios & workshops space", "Studios & Workshops property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("studios & gallery space", "Studios & Gallery property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("retail space", "Retail property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("leisure & hospitality space", "Leisure & Hospitality property")

          meta_desc = `Check out the latest collection of ${hTitle.replace(/-/g, ' ').toLowerCase()} ${actionStrDesc} in ${area_capitalize} ${priceStr} with Strettons estate agents in ${area_capitalize}.`
        }

        if(priceStr && bed_room){
          meta_desc = `Explore the list of property ${actionStrDesc} in ${area_capitalize} with ${bed_room} ${priceStr} with Strettons and request a viewing for the property that interests you.`
        }

        if(h1_type && bed_room){
          let hTitle = h1_type.replace(/-/g, ' ').toLowerCase().replace("medicals space", "medical property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("industrials & logistics space", "Industrials & Logistics property")
          //hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("educationals space", "Educationals property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("investments", "investments property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("lands & developments", "Land & Development opportunities")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("studios & workshops space", "Studios & Workshops property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("studios & gallery space", "Studios & Gallery property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("retail space", "Retail property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("leisure & hospitality space", "Leisure & Hospitality property")
          meta_desc = `Find the latest collection of ${hTitle.replace(/-/g, ' ').toLowerCase()} ${actionStrDesc} in ${area_capitalize} with ${bed_room}. Contact Strettons estate agents and letting agents in ${area_capitalize}, to arrange a viewing.`
        }

        if(h1_type && sizeStr){
          let hTitle = h1_type.replace(/-/g, ' ').toLowerCase().replace("medicals space", "medical property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("industrials & logistics space", "Industrials & Logistics property")
          //hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("educationals space", "Educationals property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("investments", "investments property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("lands & developments", "Land & Development opportunities")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("studios & workshops space", "Studios & Workshops property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("studios & gallery space", "Studios & Gallery property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("retail space", "Retail property")
          hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("leisure & hospitality space", "Leisure & Hospitality property")

          meta_desc = `Looking for a ${hTitle.replace(/-/g, ' ').toLowerCase()} ${actionStrDesc} in ${area_capitalize} ${sizeStr}? Strettons ${department} estate agents are here to help.`
          //title = title.replace("from", "with size from")
        }

        if(h1_type && priceStr && (bed_room || sizeStr)){
          meta_desc = `Explore ${bed_room ? bed_room : ''} ${h1_type.replace(/-/g, ' ').toLowerCase()} ${actionStrDesc} ${sizeStr ? sizeStr : ''} in ${area_capitalize} ${priceStr} available with Strettons. Contact one of our estate agents for assistance in finding your property in ${area_capitalize}.`
          if(pcategorytype === "commercial" && sizeStr && searchParams?.pType === "sales" || searchParams?.pType === "lettings") {

            let hTitle = h1_type.replace(/-/g, ' ').toLowerCase().replace("medicals space", "medical property")
            hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("industrials & logistics space", "Industrials & Logistics property")
            //hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("educationals space", "Educationals property")
            hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("investments", "investments property")
            hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("lands & developments", "Land & Development opportunities")
            hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("studios & workshops space", "Studios & Workshops property")
            hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("studios & gallery space", "Studios & Gallery property")
            hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("retail space", "Retail property")
            hTitle = hTitle.replace(/-/g, ' ').toLowerCase().replace("leisure & hospitality space", "Leisure & Hospitality property")
  
              meta_desc = `Explore ${bed_room ? bed_room : ''} ${hTitle.replace(/-/g, ' ').toLowerCase()} ${actionStrDesc} ${sizeStr ? sizeStr.replace("with size","") : ''} in ${area_capitalize} ${priceStr} available with Strettons.  Contact one of our Commercial Agents for assistance in finding your property in ${area_capitalize}.`
             //title = title.replace("from", "with size from")
          }
        }
        if(sizeStr){
          title = title.replace("from", "with size from")
        }
        if(h1_type && (sizeStr||priceStr)){
          title = title.replace("Leisure & Hospitality property", "Leisure & Hospitality Space")
        }

    }
 
     //
     let titlePropertyType = ""

     //console.log("seo_type", type, pcategorytype)
 
     if(h1_type == "") {
         titlePropertyType = ""
     } else if(h1_type == "apartment") {
         titlePropertyType = "Apartments "
     } else if(h1_type == "house") {
         titlePropertyType = "Houses "
     } else if(h1_type == "maisonette") {
         titlePropertyType = "Maisonette "
     } else if(h1_type == "bungalow") {
         titlePropertyType = "Bungalows "
     } else if(h1_type == "land") {
         titlePropertyType = "Land "
     } else {
         titlePropertyType = h1_type+" "
     }
 
     let bedroomType = ""

     let department_ttl = "";

     if(srch_department === "investment"){
      department_ttl = titlePropertyType.toLowerCase() + srch_department+" property";
     } else{
      department_ttl = titlePropertyType + pcategorytype === "residential" ? "property" : pcategorytype+" property";
     }
 
     if ( bedrooms ) {
       bedroomType = bedrooms + ' + Bedroom '
     }
 
    //  let descTitle = bedroomType + toTitleCase(department_ttl.replace(/-/g, ' ')) + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + priceStr + mustIncludeTitle
    let descTitle = title;

     //
 
   // console.log("Props Desc => ", desc);
 
   description = desc;

   var { pathname } = useLocation()

   const siteUrl = (process.env.GATSBY_SITE_URL || "https://www.strettons.co.uk").replace(/\/+$/, "");

   var currentUrl = '';
   currentUrl = siteUrl + pathname;

   // set no index for result pagination
   let hasPagination = false;
   if (pathname !== undefined && pathname) {
     let pageStr = pathname.split('page-');
     hasPagination = pageStr[1] || false;
     if (pageStr[0] !== undefined) {
      currentUrl = siteUrl + pageStr[0];
     }
   }
 
   if (!currentUrl.endsWith('/'))
   currentUrl = currentUrl + '/';
 
   //remove multiple slashes
   currentUrl = currentUrl.replace(/([^:]\/)\/+/g, "$1");
   //set lowercase url
   currentUrl = currentUrl.toLowerCase();

   let pageUrl = `${siteUrl}${pathname || location || "/"}`;
   if (!pageUrl.endsWith('/')) {
     pageUrl = pageUrl + '/';
   }
   pageUrl = pageUrl.replace(/([^:]\/)\/+/g, "$1").toLowerCase();

   const cleanHeading = (descTitle || "").replace(/\s+/g, " ").trim();
   const cleanDescription = (meta_desc || "").replace(/\s+/g, " ").trim();
   const searchResultsSchema = Array.isArray(hits) && hits.length > 0
     ? buildSearchResultsSchema({
         pageUrl,
         siteUrl,
         name: cleanHeading ? `${cleanHeading} | Strettons` : "Strettons",
         description: cleanDescription,
         mainEntityName: cleanHeading,
         items: hits,
       })
     : null;

 
   let metaItems = [
     {
       name: `description`,
       content: meta_desc,
     },
     {
       property: `og:title`,
       content: descTitle,
     },
     {
       property: `og:description`,
       content: meta_desc,
     },
     {
       property: `og:type`,
       content: `website`,
     },
     {
      name: `og:url`,
      content: currentUrl,
     },
     {
       name: `twitter:card`,
       content: `summary`,
     },
     {
       name: `twitter:creator`,
       content: `Strettons`,
     },
     {
       name: `twitter:title`,
       content: descTitle,
     },
     {
       name: `twitter:description`,
       content: meta_desc,
     },
   ].concat(meta);
 

  //  if ( hasPagination ) {
  //    metaItems.push({
  //      name: `robots`,
  //      content: `noindex`,
  //    })
  //  }
 
   return (
     <Helmet
       htmlAttributes={{
         lang,
       }}
       link={[
        {
          href: currentUrl,
          rel: "canonical"
        }]}
       title={descTitle}
       titleTemplate={`%s | Strettons`}
       meta={metaItems}
     >
       {searchResultsSchema && (
         <script type="application/ld+json">
           {JSON.stringify(searchResultsSchema)}
         </script>
       )}
     </Helmet>
   )
 }
 
 SeoResults.defaultProps = {
   lang: `en`,
   meta: [],
   description: ``,
   title: ``,
   searchParams: [],
   hits: [],
 }
 
 SeoResults.propTypes = {
   description: PropTypes.string,
   lang: PropTypes.string,
   meta: PropTypes.arrayOf(PropTypes.object),
   title: PropTypes.string.isRequired,
   searchParams: PropTypes.any,
   hits: PropTypes.array,
 }
 
 export default SeoResults
 